import { maybeParseCalendarDate } from '@rematter/common/dateTime';
import { Loading, LocalizedDate } from '@rematter/ui-web';
import { ContentCard, ContentInfo, ContentSection } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import * as state from '../../_state/loadDetails.state';

export const AddressInfo = (props: {
  address?: {
    streetAddress: string;
    city: string;
    state: string;
    postalCode: string;
  };
}) =>
  props.address ? (
    <div>
      <div>{props.address.streetAddress}</div>
      <div>
        {props.address.city}, {props.address.state} – {props.address.postalCode}
      </div>
    </div>
  ) : (
    <div>–</div>
  );

export const LoadTabInfo = () => {
  const { data: load, isLoading } = useAtomValue(state.$loadDetails);

  return (
    <div className="@LoadTabInfo flex flex-col gap-5 p-5">
      <Loading isLoading={isLoading}>
        <ContentCard>
          {load && (
            <>
              <ContentSection title="Load Info">
                <div className="grid grid-cols-4 gap-4 text-sm">
                  <ContentInfo
                    label="Purchase Order #"
                    value={load.purchaseOrderNumber}
                  >
                    {(po) => `PO #${po}`}
                  </ContentInfo>
                  <ContentInfo
                    label="Booking #"
                    value={load.booking?.documentNumber}
                  >
                    {(bk) => `BK #${bk}`}
                  </ContentInfo>
                  <ContentInfo label="Supplier" value={load.supplier?.name}>
                    {(supplier) => supplier}
                  </ContentInfo>
                  <ContentInfo
                    label="Supplier Location"
                    value={load.supplier?.addresses?.at(0)}
                  >
                    {(location) => <AddressInfo address={location.address} />}
                  </ContentInfo>
                </div>
              </ContentSection>
              <ContentSection title="Shipment Info">
                <div className="grid grid-cols-4 gap-4 text-sm">
                  <ContentInfo
                    label="Vessel ETA Date"
                    value={load.expectedShipDate}
                  >
                    {(eta) => (
                      <div className="flex flex-col gap-2">
                        <LocalizedDate
                          date={maybeParseCalendarDate(eta)}
                          dateStyle="medium"
                        />
                      </div>
                    )}
                  </ContentInfo>
                  <ContentInfo label="Shipped Date" value={load.shippedDate}>
                    {(shippedDate) => (
                      <div className="flex flex-col gap-2">
                        <LocalizedDate
                          date={maybeParseCalendarDate(shippedDate)}
                          dateStyle="medium"
                        />
                      </div>
                    )}
                  </ContentInfo>
                  <ContentInfo
                    colspan={2}
                    label="Vessel Name"
                    value={load.booking?.vesselName}
                  >
                    {(vesselName) => vesselName}
                  </ContentInfo>
                  <ContentInfo label="Container #" value={load.containerNumber}>
                    {(containerNumber) => `#${containerNumber}`}
                  </ContentInfo>
                  <ContentInfo label="Seal #" value={load.sealNumber}>
                    {(sealNumber) => `#${sealNumber}`}
                  </ContentInfo>
                  <ContentInfo label="Release #" value={load.releaseNumber}>
                    {(releaseNumber) => `#${releaseNumber}`}
                  </ContentInfo>
                </div>
              </ContentSection>
              <ContentSection title="Notes">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>{load.recyclerExternalNotes ?? '–'}</div>
                </div>
              </ContentSection>
            </>
          )}
        </ContentCard>
      </Loading>
    </div>
  );
};
